import {
  createEditorTranslator,
  type EditorTranslate,
  type Locale,
} from '@eklevo/shared/i18n/editor'
import { createContext, useContext, useMemo, type ReactNode } from 'react'

/*
 * The editor's texts (@eklevo/shared/i18n/editor), in the language of the surface it is mounted
 * in, which gives it: HR's console and the back office each have their own catalog and their own
 * choice of language, and the editor carries neither.
 */

interface EditorI18n {
  locale: Locale
  t: EditorTranslate
}

const EditorI18nContext = createContext<EditorI18n | null>(null)

export function EditorI18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  const value = useMemo(() => ({ locale, t: createEditorTranslator(locale) }), [locale])
  return <EditorI18nContext.Provider value={value}>{children}</EditorI18nContext.Provider>
}

export function useEditorI18n(): EditorI18n {
  const value = useContext(EditorI18nContext)
  if (!value) throw new Error('useEditorI18n must be used inside EditorI18nProvider')
  return value
}
